/* Swap the hero's background image as the slider moves.

   The theme paints one image for the whole band, positioned absolutely and
   sized by CSS that already works. Putting a real <img> inside each slide
   instead fought that CSS on every axis, so the element stays exactly where
   it is and only its src changes. Each slide carries its own URL in
   data-slide-img, printed by homeslider.liquid. */
(function () {
  function init() {
    var section = document.querySelector('.first-video-section');
    if (!section) return;
    var img = section.querySelector(':scope > img');
    var slider = section.querySelector('.banner-slider');
    if (!img || !slider || !window.jQuery) return;

    /* Read the URL off whichever slide slick has marked current, rather than
       indexing the non-cloned slides. In infinite mode the index slick
       reports and the position in that list drift apart, which showed the
       previous slide's photograph next to the new slide's words. Clones carry
       the same attribute, so a clone being current is fine. */
    function currentUrl() {
      var cur = slider.querySelector('.slick-current');
      return cur ? cur.getAttribute('data-slide-img') : null;
    }

    function show() {
      var url = currentUrl();
      if (!url || img.getAttribute('src') === url) return;
      var next = new Image();
      next.onload = function () {
        /* The slider can move on while a photograph is still downloading.
           Without this check the image that finally arrives belongs to the
           slide before the one now on screen, which is how the matcha words
           ended up next to the subscription box. */
        if (currentUrl() === url) img.src = url;
      };
      next.src = url;
    }

    /* Warm every slide's photograph once, so after the first pass the swap is
       instant and always lands on the right slide. */
    function preload() {
      slider.querySelectorAll('[data-slide-img]').forEach(function (el) {
        var u = el.getAttribute('data-slide-img');
        if (u) { var i = new Image(); i.src = u; }
      });
    }

    jQuery(slider).on('afterChange init reInit', function () { show(); });
    show();
    preload();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
